import {
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../shares/AppButton";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import { useNavigate } from "react-router-dom";
import useConfirm from "../../../hooks/useConfirm";
import { userServices } from "../../../service/UserService";

const INIT_PWD_INFO = {
  old_mdp: "",
  new_mdp: "",
  confirm_mdp: "",
};

const INIT_FORM_ERROR = {
  old_mdp_error: null,
  new_mdp_error: null,
  confirm_mdp_error: null,
};
const ChangePasswordForm = ({
  open,
  onFormClose,
  onFormOpen,
  idAssociation,
}) => {
  const [passwordInfo, setpasswordInfo] = useState(INIT_PWD_INFO);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { Toast, showToast } = useToast();
  const navigate = useNavigate();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleFormClose = () => {
    onFormClose();
    setpasswordInfo(INIT_PWD_INFO);
  };

  const handleChangePasswordInfo = (e) => {
    const { name, value } = e.target;
    setpasswordInfo({ ...passwordInfo, [name]: value });
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      old_mdp_error: !passwordInfo.old_mdp
        ? "L'ancien mot de passe est requis"
        : null,
      new_mdp_error: !passwordInfo.new_mdp
        ? "Le nouveau mot de passe est requis"
        : passwordInfo.new_mdp.length < 6
          ? "6 caracteres au minimum requis"
          : null,
      confirm_mdp_error: !passwordInfo.confirm_mdp
        ? "La confirmation mot de passe est requis"
        : passwordInfo.new_mdp !== passwordInfo.confirm_mdp
          ? "La confirmation doit être identique au nouveau mot de passse"
          : passwordInfo.old_mdp === passwordInfo.confirm_mdp
            ? "L'ancien et le nouveau mot de passe sont identiques"
            : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleInsertNewPassword = () => {
    setSubmited(true);
    setSubmitting(true);
    userServices
      .changePassword(passwordInfo)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setSubmitting(false);
      });
  };

  const handleSubmit = () => {
    setSubmited(true);
    if (handleCheckDataValidation()) {
      handleInsertNewPassword();
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  useEffect(() => {
    if (passwordInfo) {
      handleCheckDataValidation();
    }
  }, [passwordInfo]);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader title={"Modifier mot de passe"} />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Ancien mot de passe</label>
                  <TextField
                    id="old_mdp"
                    name="old_mdp"
                    onChange={handleChangePasswordInfo}
                    size="small"
                    type="password"
                    value={passwordInfo.old_mdp || ""}
                    error={formErrors.old_mdp_error && submited}
                    // error={formErrors.adresse_error && submited}
                    helperText={submited ? formErrors.old_mdp_error : ""}
                    placeholder="*******"
                    fullWidth
                    aria-describedby="pwd_helper"
                  />
                  <FormHelperText id="pwd_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Nouveau mot de passe</label>
                  <TextField
                    id="new_mdp"
                    name="new_mdp"
                    onChange={handleChangePasswordInfo}
                    size="small"
                    type="password"
                    value={passwordInfo.new_mdp || ""}
                    error={formErrors.new_mdp_error && submited}
                    // error={formErrors.adresse_error && submited}
                    helperText={submited ? formErrors.new_mdp_error : ""}
                    placeholder="*******"
                    fullWidth
                    aria-describedby="new_pwd_helper"
                  />
                  <FormHelperText id="new_pwd_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Confirmer mot de passe</label>
                  <TextField
                    id="confirm_mdp"
                    name="confirm_mdp"
                    onChange={handleChangePasswordInfo}
                    size="small"
                    type="password"
                    value={passwordInfo.confirm_mdp || ""}
                    error={formErrors.confirm_mdp_error && submited}
                    // error={formErrors.adresse_error && submited}
                    helperText={submited ? formErrors.confirm_mdp_error : ""}
                    placeholder="*******"
                    fullWidth
                    aria-describedby="confirm_helper"
                  />
                  <FormHelperText id="confirm_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={submitting}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={(e) => handleSubmit()}
              />
              <AppButton
                text={"Fermer"}
                size={"medium"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default ChangePasswordForm;
